import React from "react";
import PropTypes from "prop-types";
import styles from "./Steps.module.css";

// icons
import { ReactComponent as TickIcon } from "./../../../../assets/svg/tick.svg";
import { ReactComponent as CustomerDataIcon } from "./../../../../assets/svg/customer-data.svg";
import { ReactComponent as SelectServiceIcon } from "./../../../../assets/svg/select-service.svg";
import { ReactComponent as VerifyIcon } from "./../../../../assets/svg/verify.svg";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const stepsList = [
  {
    step: 1,
    name: "customer_data",
    href: "/new-service",
    icon: CustomerDataIcon,
  },
  {
    step: 2,
    name: "select_service",
    icon: SelectServiceIcon,
    href: "/select-service",
  },
  {
    step: 3,
    name: "verification",
    icon: VerifyIcon,
    href: null,
  },
];

const Steps = ({
  step = 1,
  open,
  hasShadow = false,
  disableCustomerData = false,
  locked = false,
}) => {
  const navigate = useLangNavigate();
  const { t } = useTranslation();

  const itemClick = (href, itemStep) => {
    // Once the flow is locked (e.g. verification already completed/failed),
    // there's nothing left to navigate back into.
    if (locked) {
      return;
    }

    if (disableCustomerData && itemStep === 1) {
      return;
    }

    if (typeof href === "string" && itemStep < step) {
      navigate(href);
    }
  };

  return (
    <div
      className={`${styles.StepsContainer} ${open ? styles.Open : ""} ${hasShadow ? styles.Shadow : ""
        }`}
    >
      <div className={styles.Steps}>
        {stepsList.map((stepItem, stepItemIndex) => {
          const Icon = stepItem.icon;

          const isClickable =
            !locked &&
            stepItem.step < step &&
            !(disableCustomerData && stepItem.step === 1);

          return (
            <React.Fragment key={stepItem.step}>
              {stepItemIndex > 0 && (
                <div
                  className={`${styles.BackLine} ${step - 1 >= stepItemIndex ? styles.Active : ""
                    }`}
                />
              )}

              <div
                onClick={() => itemClick(stepItem.href, stepItem.step)}
                className={`${styles.StepItem}
                  ${stepItemIndex + 1 < parseInt(step)
                    ? styles.Done
                    : ""
                  }
                  ${stepItemIndex + 1 === parseInt(step)
                    ? styles.Active
                    : ""
                  }
                  ${isClickable ? styles.Cursor : ""
                  }`}
              >
                <div className={styles.StepItemIndex}>
                  {stepItemIndex + 1 >= parseInt(step) && stepItemIndex + 1}

                  {stepItemIndex + 1 < parseInt(step) && (
                    <TickIcon className={styles.TickIcon} />
                  )}
                </div>

                <Icon
                  className={`${styles.StepItemIcon} ${step - 1 === stepItemIndex ? styles.Active : ""
                    } ${stepItem.className}`}
                />

                <span className={styles.StepItemName}>
                  {t(`new_service.${stepItem.name}`)}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

Steps.propTypes = {
  data: PropTypes.array.isRequired,
  step: PropTypes.number || PropTypes.string,
  className: PropTypes.string,
  locked: PropTypes.bool,
};

export default Steps;